/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Tariffs And Services Side Menu Styled
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.25.1
 * @since 1.4.0
 */

import styled from 'styled-components';

import { FOOTER_HEIGHT } from '@/main/components/common/Footer/styled/FooterStyled';
import { colors, fonts } from '@theme/index';

interface IAccordionItemStyled {
    disabled: boolean;
    isActive: boolean;
    isParentActive: boolean;
    level: number;
}

export const AccordionItemStyled = styled.div.attrs(
    ({ disabled, isActive, isParentActive, level }: IAccordionItemStyled) => ({
        className: [
            'accordion-item',
            `${isActive ? ' active' : ''}`,
            `${isParentActive ? ' parent-active' : ''}`,
            `${level ? ` level-${level}` : ''}`,
            `${disabled ? ' disabled' : ''}`,
        ].join(''),
    }),
)<IAccordionItemStyled>`
    padding: 12px 20px;
    cursor: pointer;
    border-bottom: 1px solid ${colors.tariffsAndServicesSideBordersColor};
    border-left: 1px solid transparent;

    display: flex;
    flex-direction: row;
    align-items: center;

    span {
        flex: 1;
    }

    > div {
        transition: transform 200ms linear;
    }

    &.level-3 {
        padding-left: 32px;
    }

    &.active {
        border-left-color: ${colors.tariffsAndServicesSideLeftBorderColorHover};
    }

    &:hover {
        background: ${colors.tariffsAndServicesSideBgColorHover};
    }

    &.active {
        ${fonts.textMainBold}
    }

    &.parent-active.level-1 {
        color: ${colors.tariffsAndServicesSideLevel1ColorActive};
        background: ${colors.tariffsAndServicesSideLevel1BgColorActive};
    }

    &.disabled {
        pointer-events: none;
        color: ${colors.tariffsAndServicesSideColorDisabled};
    }

    .small {
        height: 24px;
    }
`;

export const TariffsAndServicesSideMenuStyled = styled.div`
    position: sticky;
    top: 0;
    margin-bottom: ${FOOTER_HEIGHT - 1}px;

    .accordion__item {
    }

    .accordion__heading {
    }

    .accordion__button {
        outline: none;

        &[aria-expanded='true'] {
            .accordion-item > div {
                transform: rotate(180deg);
            }
        }
    }
`;
